interface Props<T extends string | number = string> {
    name?: string
    label: React.ReactNode
    value: T
    groupValue?: T
    setValue?: (v: T) => void
    key?: number
    disabled?: boolean
}

export const RadioButton = <T extends string | number = string>({
    name,
    label,
    value,
    setValue,
    groupValue,
    key,
    disabled,
}: Props<T>): JSX.Element => {
    const checked = groupValue !== undefined ? value === groupValue : undefined

    return (
        <div className="radio radio-styled" key={key}>
            <label>
                <input
                    type="radio"
                    name={name}
                    value={value}
                    checked={checked}
                    disabled={disabled}
                    onChange={(e) => setValue(e.target.value as T)}
                />
                <span>{label}</span>
            </label>
        </div>
    )
}
